export const EXTERNAL_LINKS = {
  RAK_ID: 'https://id.rakwireless.com/about',
  HELIUM_HOTSPOTS: 'https://explorer.helium.com/hotspots',
  OPEN_SEARCH: 'https://es.wishm.network/_dashboards',
};
